var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtility9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60547 17.1129V23.244H11.2476C11.55 23.2441 11.8496 23.1845 12.129 23.0688C12.4084 22.953 12.6624 22.7834 12.8763 22.5695L23.0832 12.3627C23.5158 11.931 23.7593 11.3452 23.7602 10.734V2.10522H17.6292V14.8071C17.6296 15.1121 17.5694 15.4141 17.4521 15.6955C17.3348 15.977 17.1629 16.2324 16.9462 16.4469C16.7295 16.6614 16.4722 16.8308 16.1896 16.9451C15.9068 17.0594 15.6043 17.1165 15.2994 17.1129H2.60547Z",
    fill: "#37ABFF",
    stroke: "#37ABFF",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3689 22.8789V16.7478H29.7268C29.4244 16.7478 29.1248 16.8073 28.8454 16.9231C28.566 17.0388 28.312 17.2083 28.0981 17.4222L17.8912 27.6291C17.6774 27.843 17.5077 28.0969 17.3921 28.3763C17.2764 28.6558 17.2168 28.9553 17.2168 29.2578V37.8945H23.3478V25.182C23.3478 24.8793 23.4075 24.5796 23.5234 24.3C23.6393 24.0204 23.8092 23.7663 24.0234 23.5524C24.2375 23.3385 24.4917 23.169 24.7715 23.0534C25.0512 22.9378 25.351 22.8785 25.6536 22.8789H38.3689Z",
    fill: "#37ABFF",
    stroke: "#37ABFF",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility9);
export default __webpack_public_path__ + "static/media/utility9.6f1d87b68680494739049e7733023a70.svg";
export { ForwardRef as ReactComponent };